import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { AccessModes } from '@/domain/accessMode/accessManagerTypes';

type SetAccessModePayload = {
  group: AccessModes[];
  accessMode: AccessModes;
};

type ClearAccessModePayload = {
  group: AccessModes[];
};

const initialState: AccessModes[] = [AccessModes.VIEWER];

const filterByGroup = (state: AccessModes[], group: AccessModes[]): AccessModes[] => {
  return state.filter(item => !group.includes(item));
};

export const accessModeSlice = createSlice({
  name: 'accessMode',
  initialState,
  reducers: {
    setAccessMode: (state: AccessModes[], action: PayloadAction<SetAccessModePayload>) => {
      const { accessMode, group } = action.payload;
      return [...filterByGroup(state, group), accessMode];
    },

    clearAccessMode: (state: AccessModes[], action: PayloadAction<ClearAccessModePayload>) => {
      const { group } = action.payload;
      return [...filterByGroup(state, group)];
    },
  },
});

export const { setAccessMode, clearAccessMode } = accessModeSlice.actions;

export const accessModeReducer = accessModeSlice.reducer;
